export default __webpack_public_path__ + "static/SPAIN-3b46b3057443147d7ff6b752ad975597.svg";